<template>
    <layout :showBreadCrumb="false">
        <div class="home-page">
            <section class="container-fluid home-page__header" v-if="homeTitle">
                <div class="page-description" v-html="homeTitle"></div>
            </section>
            <div class="home-page-content d-flex flex-column">
                <news-highlight
                    :class="`order-${newsOrder}`"
                    :title="newsSettings.title"
                    classTitle=""
                    :viewMore="true"
                 />
                <!-- <section class="container-fluid home-page__modules"> -->
                    <dashboard-list
                        class="container-fluid home-page__modules"
                        :class="`order-${modulesOrder}`"
                        listClass="col-sm-6 col-xxl-4"
                        :title="modulesSettings.title"
                        :listBackoffice="false"
                        :listInactive="false"
                        :limit="modulesSettings.limit" />
                <!-- </section> -->
            </div>
        </div>
    </layout>
</template>

<script>
    import Layout from '../layouts/Main.vue';
    import NewsHighlight from '../elements/news/NewsHighlight.vue';
    import DashboardList from '../elements/dashboard/DashboardList.vue';
    import mixin from '../mixin';

    export default {
        mixins: [ mixin ],
        components: {
            NewsHighlight,
            DashboardList,
            Layout,
        },
        data() {
            return {
                newsKey: 'news',
                modulesKey: 'modules',
            }
        },
        computed: {
            settings() {
                return this.$store.getters.getSettings(this.moduleCode, 'home') || {};
            },
            homeSettings() {
                return this.settings.home || {};
            },
            newsSettings() {
                return this.homeSettings.news || {};
            },
            modulesSettings() {
                return this.homeSettings.modules || {};
            },
            homeTitle() {
                return this.homeSettings && this.homeSettings.title ? this.homeSettings.title : null;
            },
            newsOrder() {
                return (this.newsSettings.order || 1) <= (this.modulesSettings.order || 2) ? 1 : 2;
            },
            modulesOrder() {
                return (this.modulesSettings.order || 2) < (this.newsSettings.order || 1) ? 1 : 2;
            },
        },

    }
</script>
